import { gql, useLazyQuery } from "@apollo/client";
import { useMemo, useState } from "react";
import useProcessData from "../../../CommonFunction/ProcessData";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import Loading from "../Loading/Loading";
import LoadTable from "../LoadTable/LoadTable";
import { WarningToast } from "../ToastComponent/RectHotToast";
import "./FormConfiguration.scss";

const queryfunction = (fields) => {
  const query = gql`
  query GetFormFields($formKey: String) {
    getFormFields(formKey: $formKey) {
      _id
        ${fields?.join(" ")}
      }
    }`;
  return query;
};

const DefaultFormFieldsModal = ({ formKey, getFormSectionAndFields, IsRefetch, setIsRefetch, setUpdatedRows , ToGetDefaultValues}) => {
  const [formData, setFormData] = useState([]);
  const [isLoader, setIsLoader] = useState(true);
  const Key = "Default_Fields";
  const [selectedRows, setSelectedRows] = useState({});

  const [fetchDefaultFields, { loading: queryLoading, error, data, refetch }] = useLazyQuery(queryfunction(), {
    variables: {
      formKey: formKey,
    },
    fetchPolicy: "network-only",
    onCompleted: () => {
      setIsLoader(false);
    },
    onError: () => {
      setIsLoader(false);
    },
  });

  const handleChange = (event, obj, columnName) => {
    setSelectedRows((prev) => {
      // If the same checkbox is clicked again, unselect it
      if (prev[obj._id] === columnName) {
        WarningToast("This selection has been cleared, returning to default values.");
        return { ...prev, [obj._id]: "" }; // Unselect
      } else {
        return { ...prev, [obj._id]: columnName }; // Select new option
      }
    });

    let variablesObj = {};
    if (columnName === "Suppressed/Disable") {
      variablesObj = { id: obj?._id, userInput: { Active: !event.target.checked, isRequired: false } };
    } else if (columnName === "Compulsory") {
      variablesObj = { id: obj?._id, userInput: { Active: true, isRequired: true } };
    } else if (columnName === "Optional") {
      variablesObj = { id: obj?._id, userInput: { Active: true, isRequired: false } };
    }

    setUpdatedRows((prevRows = []) => {
      const updatedArray = [...prevRows];
      const existingIndex = updatedArray.findIndex((row) => row.id === obj._id);

      if (existingIndex !== -1) {
        if (
          updatedArray[existingIndex].userInput.Active === variablesObj.userInput.Active &&
          updatedArray[existingIndex].userInput.isRequired === variablesObj.userInput.isRequired
        ) {
          // If the same value exists, remove it (toggle behavior)
          updatedArray.splice(existingIndex, 1);
        } else {
          // Update existing entry
          updatedArray[existingIndex] = variablesObj;
        }
      } else {
        // Add new entry if not found
        updatedArray.push(variablesObj);
      }
      return updatedArray;
    });
  };

  const config = useMemo(
    () => ({
      dataKey: "getFormFields",
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["__typename", "Active"],
      AddCol: [
        {
          colName: "Suppressed",
          value: (obj) => (
            <input
              type="checkbox"
              checked={selectedRows[obj._id] ? selectedRows[obj._id] === "Suppressed/Disable" : !obj?.Active}
              onChange={(e) => handleChange(e, obj, "Suppressed/Disable")}
              style={{ cursor: "pointer" }}
            />
          ),
        },
        {
          colName: "Compulsory",
          value: (obj) => (
            <input
              type="checkbox"
              checked={
                selectedRows[obj._id] ? selectedRows[obj._id] === "Compulsory" : obj?.Active ? obj?.isRequired : false
              }
              onChange={(e) => handleChange(e, obj, "Compulsory")}
              style={{ cursor: "pointer" }}
            />
          ),
        },
        {
          colName: "Optional",
          value: (obj) => {
            console.log(obj, "aaaaaaa", obj?.Active ? !obj?.isRequired : false);
            return (
              <input
                type="checkbox"
                checked={
                  selectedRows[obj._id] ? selectedRows[obj._id] === "Optional" : obj?.Active ? !obj?.isRequired : false
                }
                onChange={(e) => handleChange(e, obj, "Optional")}
                style={{ cursor: "pointer" }}
              />
            );
          },
        },
      ],
    }),
    [selectedRows]
  );

  const { loading } = useFetchTableData(queryfunction, fetchDefaultFields, setIsLoader, Key);

  console.log(IsRefetch, "IsRefetch");

  if (IsRefetch) {
    console.log(IsRefetch, "IsRefetch");
    refetch().then(() => {
      getFormSectionAndFields().then(() => {
        setIsRefetch(false);
      });
    });
  }

  const { loading: processDataLoading } = useProcessData(data, setFormData, config, error);

  const isLoading = queryLoading || isLoader;

  return (
    <div className="Custom_Fields_Container">
      {isLoading || processDataLoading ? (
        <Loading />
      ) : !formData?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <div className="Fields_Container_Scroll_Bar">
          {(queryLoading || loading) && <div className="loader-line-div" />}
          <LoadTable
            title={Key}
            data={formData}
            loading={isLoading}
            error={error}
            settings={false}
            options={false}
            select={false}
            dragDrop={false}
          />
        </div>
      )}
    </div>
  );
};

export default DefaultFormFieldsModal;
